import { Flex, Image, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H4 } from "src/atoms/typography";
import { useApp } from "src/components/App/Context";
import cameraImage from "./camera-unavailable.svg";

export default function NoCameraMode({ hasCameraPermission }) {
  const app = useApp();
  const { t } = useTranslation();
  return (
    <Flex
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      pb="10vh"
      bg="black87"
    >
      <Image src={cameraImage} width="80px" height="80px" mb="8px" />
      <H4 color="white40" width="320px" textAlign="center">
        {hasCameraPermission
          ? t("cameraNotAvailable")
          : t("babyStation.noCameraMode.noPermission.text")}
      </H4>
      {!hasCameraPermission && (
        <Button
          variant="flatPrimary"
          onClick={() => app.permissions.openSettings("camera")}
          mt="8px"
        >
          {t("settings")}
        </Button>
      )}
    </Flex>
  );
}
